export default {
	title: "Display / TV",
	subtitle: "Gerencie mensagens e vídeos exibidos na TV do templo",
	newMessage: "Nova Mensagem",
	editMessage: "Editar Mensagem",
	messageTitle: "Título",
	content: "Conteúdo",
	type: "Tipo",
	types: {
		TEXT: "Texto",
		VIDEO: "Vídeo",
	},
	videoUrl: "URL do Vídeo (YouTube)",
	showInQueue: "Mostrar em fila (rodapé da TV)",
	sortOrder: "Ordem",
	active: "Ativo",
	inactive: "Inativo",
	totalMessages: "Total",
	controls: {
		title: "Controle do Display",
		sendMessage: "Enviar Mensagem",
		playVideo: "Tocar Vídeo",
		clearDisplay: "Limpar Display",
	},
	messages: {
		created: "Mensagem criada com sucesso",
		updated: "Mensagem atualizada com sucesso",
		deleted: "Mensagem excluída com sucesso",
		sent: "Mensagem enviada para o display",
		videoSent: "Vídeo enviado para o display",
		cleared: "Display limpo",
		confirmDelete: "Tem certeza que deseja excluir esta mensagem?",
	},
	oriTv: {
		title: "App ORI TV",
		description: "Instale o app ORI TV na sua Fire TV Stick ou Android TV para exibir chamadas de fichas, mensagens e vídeos na tela do templo.",
		step1: "Baixe e instale o APK no dispositivo (Fire TV Stick, Android TV ou tablet)",
		step2: "Abra o app e acesse o endereço exibido na tela para autorizar",
		step3: "Pronto! As fichas e mensagens aparecerão automaticamente na TV",
		download: "Baixar ORI TV (.apk)",
		compatibility: "Compatível com Fire TV Stick, Android TV e tablets Android",
		version: "Versão",
	},
	deviceAuth: {
		title: "Autorizar Dispositivo",
		subtitle: "Conecte uma TV ou dispositivo ao templo",
		enterCode: "Digite o código exibido na TV",
		selectTemple: "Selecionar Templo",
		authorize: "Autorizar Dispositivo",
		success: "Dispositivo autorizado com sucesso!",
		successDesc: "A TV já pode exibir as fichas do seu templo.",
		error: "Erro ao autorizar dispositivo",
	},
};
